import React from "react";
import { capabilities, training, education } from "../mock/mock";
import { GraduationCap, Award } from "lucide-react";

const SkillsEducation = () => {
  return (
    <section id="capabilities" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Capabilities & Credentials
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              The craft, the credentials and the continuing education.
            </h2>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          {/* Capability clusters — 4 grouped */}
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {capabilities.map((g) => (
              <div
                key={g.group}
                className="bg-ivory-100/60 border border-ink/10 rounded-sm p-6"
              >
                <h3 className="font-serif-display text-lg text-ink mb-4">{g.group}</h3>
                <ul className="space-y-2">
                  {g.items.map((s) => (
                    <li
                      key={s}
                      className="flex items-start gap-2.5 text-sm text-ink/80 leading-snug"
                    >
                      <span className="mt-2 h-1 w-1 rounded-full bg-bronze flex-shrink-0" />
                      <span>{s}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Education + certifications */}
          <div className="lg:col-span-5 space-y-10">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <GraduationCap className="h-5 w-5 text-bronze" />
                <h3 className="font-serif-display text-xl text-ink">Education</h3>
              </div>
              <ul className="space-y-5">
                {education.map((e, i) => (
                  <li key={i} className="border-l border-bronze/40 pl-5">
                    <div className="text-xs uppercase tracking-[0.22em] text-bronze mb-1">
                      {e.year}
                    </div>
                    <div className="font-serif-display text-lg text-ink leading-tight">
                      {e.degree}
                    </div>
                    <div className="text-sm text-ink/65 mt-1">{e.school}</div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="border-t border-ink/10 pt-10">
              <div className="flex items-center gap-3 mb-6">
                <Award className="h-5 w-5 text-bronze" />
                <h3 className="font-serif-display text-xl text-ink">Certifications</h3>
              </div>
              <div className="grid grid-cols-3 gap-3">
                {training.map((t) => (
                  <div
                    key={t}
                    className="text-center py-4 px-3 border border-ink/10 rounded-sm text-sm text-ink/80 hover:bg-ink hover:text-ivory-50 hover:border-ink transition-colors cursor-default"
                  >
                    {t}
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-ink/10 pt-6 text-sm text-ink/65">
              <span className="uppercase tracking-[0.22em] text-[11px] text-ink/55">
                Languages
              </span>
              <div className="mt-2 text-ink">English (Proficient) · Arabic (Native)</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsEducation;
